import { AppNavRail } from './AppNavRail';
import { AppNavTabBar } from './AppNavTabBar';
import { AppNavTopBar } from './AppNavTopBar';
import { type AppNavProps } from './AppNav.types';
import { useAppNav } from './useAppNav';

import { useFormat } from '@/hooks/useFormat';
import { NAV_LAYOUT_BY_FORMAT } from '@/tokens/breakpoints';

const PRESENTERS = {
  tabbar: AppNavTabBar,
  topbar: AppNavTopBar,
  rail: AppNavRail,
} as const;

/**
 * Navigation applicative — cas d'école de la « règle des 10 % ».
 *
 * Les trois formats ne sont pas la même UI redimensionnée : ce sont trois
 * structures DOM différentes (barre basse, barre haute, rail). On bascule donc
 * au niveau du conteneur, pas dans les classes.
 *
 * Warning: Rendu conditionnel réel, et surtout PAS trois navigations montées puis
 * masquées en CSS : ça triplerait le DOM, dupliquerait les requêtes d'images,
 * et ferait annoncer trois navigations par un lecteur d'écran.
 */
export function AppNav({ forceLayout, ...props }: Readonly<AppNavProps>) {
  const format = useFormat();
  const layout = forceLayout ?? NAV_LAYOUT_BY_FORMAT[format];
  const { items, overflowItems } = useAppNav(layout, {
    hasFamily: props.hasFamily,
  });

  const Presenter = PRESENTERS[layout];
  return <Presenter {...props} items={items} overflowItems={overflowItems} />;
}
